/**
 * JsonLd — injects a <script type="application/ld+json"> block into <head>
 * via react-helmet-async. Pass any valid schema.org object or @graph array.
 */
import { Helmet } from "react-helmet-async";

interface JsonLdProps {
  data: object;
}

export default function JsonLd({ data }: JsonLdProps) {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}
